export default __webpack_public_path__ + "static/careers-1-7f528565ad7b9574507ef0e7db932370.svg";